'use client';

import { VideoImageData } from '@workspace/interfaces';
import { cn } from '@workspace/lib';

import { AppVideoImage } from '@/app/common';

interface VideoImageRendererProps {
  block: VideoImageData;
}
export const VideoImageRenderer = ({ block }: VideoImageRendererProps) => {
  const { imageHeading, textOverlay, variant, buttons, description, heading, image, isVideo, thumbnail, video, width } =
    block;
  const isContentWidth = variant === 'videoWithoutText' && width === 'contentWidth';
  return (
    <div className={cn('bg-black', isContentWidth && 'porta-container')}>
      <AppVideoImage
        variant={variant}
        imageHeading={imageHeading}
        textOverlay={textOverlay}
        buttons={buttons}
        description={description}
        heading={heading}
        image={image}
        isVideo={isVideo}
        thumbnail={thumbnail}
        video={video}
        wrapperClassName={isContentWidth ? undefined : 'xl:min-h-[56.25vw]'}
      />
    </div>
  );
};
